"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var propTypes_1 = require("../InputSmarttag/propTypes");
var Tag_1 = __importDefault(require("./Tag"));
var SmarttagTags = function (props) {
    var items = props.items, onChange = props.onChange, onClickTag = props.onClickTag, showWhitespace = props.showWhitespace, disabled = props.disabled;
    var renderTag = function (item, smarttagName, smarttagTitle) {
        return (React.createElement(Tag_1.default, { key: item.key, showWhitespace: showWhitespace, disabled: disabled, onClick: onClickTag &&
                (function () {
                    onClickTag(smarttagName, item.key);
                }), onClickRemove: function (e) {
                e.stopPropagation();
                onChange(items.reduce(function (prev, smarttag) {
                    if (smarttag.key === smarttagName) {
                        var values = smarttag.values.filter(function (val) {
                            return val.key !== item.key;
                        });
                        if (values.length > 0) {
                            return __spreadArrays(prev, [__assign(__assign({}, smarttag), { values: values })]);
                        }
                        return prev;
                    }
                    return __spreadArrays(prev, [smarttag]);
                }, []));
            }, removable: typeof onChange === 'function', title: smarttagTitle || smarttagName, subtitle: item.title || item.key }));
    };
    var renderGroup = function (item) {
        return item.values.map(function (value) {
            return renderTag(value, item.key, item.title);
        });
    };
    if (items.length > 0) {
        return items.map(renderGroup);
    }
    return null;
};
SmarttagTags.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    onClickTag: PropTypes.func,
    items: propTypes_1.smarttagsPropType.isRequired,
    showWhitespace: PropTypes.bool,
    disabled: PropTypes.bool,
};
SmarttagTags.defaultProps = {
    className: null,
    onChange: null,
    onClickTag: null,
    showWhitespace: false,
    disabled: false,
};
exports.default = SmarttagTags;
